import { ValidationApiError } from "@anna-money/anna-web-lib/api";
import { extractBackendValidationError } from "helpers/forms/errors";
import { type CompanyFormValues } from "helpers/forms/incorporation/companyTypes";
import { CompanyAddressStoreBase } from "services/companyAddress/companyAddressStoreBase";
import { FormError } from "types/errors";
import type { FormSubmitResult } from "types/form";

const COMPANY_ALREADY_HAS_ADDRESS_CODE = 1050;

export type CompanyAddressFormValues = Pick<
  CompanyFormValues,
  "useVirtualOffice" | "virtualOfficeBillingPeriod" | "address" | "useHomeAddressAsRegistered"
>;

export abstract class CompanyAddressFormStoreBase {
  protected constructor(protected readonly _companyAddressStore: CompanyAddressStoreBase) {}

  async onSubmit(values: CompanyAddressFormValues): Promise<FormSubmitResult> {
    try {
      if (values.useVirtualOffice && values.virtualOfficeBillingPeriod) {
        await this._companyAddressStore.updateAddress({
          virtualOfficeBillingPeriod: values.virtualOfficeBillingPeriod,
        });
        return;
      }

      if (values.useHomeAddressAsRegistered) {
        await this._companyAddressStore.updateAddress({ useHomeAddressAsRegistered: true });
        return;
      }

      if (values.address) {
        await this._companyAddressStore.updateAddress({ address: values.address });
        return;
      }

      throw new FormError("No virtual office and no address selected");
    } catch (error) {
      if (error instanceof ValidationApiError) {
        if (error.code === COMPANY_ALREADY_HAS_ADDRESS_CODE) {
          return; // Address already exists — benign, treat as success
        }
        return extractBackendValidationError(error);
      }
      throw error;
    }
  }
}
